import { Text, Title } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

export function RegularTimeDisplay(props: { timeWorked: string; timeLeft: string }) {
  const { timeWorked, timeLeft } = props;
  return (
    <Stack alignItems="center" justifyContent="center" gap={4} sx={{ width: "100%" }}>
      <Title component="h2" variant="h2" sx={{ textAlign: "center" }}>
        {timeWorked}
      </Title>
      <Text variant="body1" sx={{ textAlign: "center" }}>
        {timeLeft}
      </Text>
    </Stack>
  );
}
